module.exports = __webpack_public_path__ + "img/appCode.104cb661.png";